import { InventoryStocktakeFormData, InventoryStocktakeRow } from './types';

export const stocktakeStatusOptions = [
  { id: 'all', name: 'Tất cả' },
  { id: 'draft', name: 'Nháp' },
  { id: 'approved', name: 'Đã xác nhận' },
  { id: 'posted', name: 'Đã ghi sổ' },
  { id: 'inactive', name: 'Ngưng dùng' },
];

export const inventoryStocktakeRows: InventoryStocktakeRow[] = [];

export const createDefaultStocktakeForm = (companyId: string): InventoryStocktakeFormData => ({
  code: '',
  name: '',
  store_name: '',
  date: new Date().toISOString().slice(0, 10),
  status: 'draft',
  company_id: companyId,
  note: '',
});
